class CollapserDemo extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="collapser">
          Collapser
          <span className="section__item-docs">
            Documentation:&nbsp;
            <a href="docs/components/class/components/Collapser.jsx~Collapser.html" target="_blank">JS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Simple Collapser</h4>
              <div className="demo__code">
                <CodeBlock lang="jsx">
                {`
@import {Collapser} from 'airtame-gooey';

...

render() {
  return (
    <Collapser title="This is my Collapser title">
      This is my collapser content
    </Collapser>
  )
}
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
// No styles needed for collapser
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="collapser-demo">
                    <Collapser title="This is my Collapser title" className="foo">
                      This is my collapser content
                    </Collapser>
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
